import React, { FunctionComponent } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

interface Props {
    color: string;
    selected: boolean;
    onSelect: () => void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        colorCircle: {
            width: 37,
            height: 37,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'box-shadow 0.2s',
            border: 'none',
            padding: 2,
            background: '#fff',
            boxSizing: 'border-box'
        },
        colorInner: {
            width: 32,
            height: 32,
            borderRadius: '50%',
            background: (props: Props) => props.color
        },
        colorCircleSelected: {
            boxShadow: '0 0 0 2px #222'
        },
        transparent: {
            border: '1px solid #D4D4D4'
        }
    })
);

export const ColorComponent: FunctionComponent<Props> = props => {
    const classes = useStyles(props);

    return (
        <Box
            className={clsx(classes.colorCircle, {
                [classes.colorCircleSelected]: props.selected,
                [classes.transparent]: props.color === 'inherit'
            })}
            onClick={props.onSelect}
            position="relative"
        >
            <Box
                className={classes.colorInner}
                position="relative"
            >
                {props.color === 'inherit' && (
                    <svg
                        width={32}
                        height={32}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            pointerEvents: 'none'
                        }}
                    >
                        <line
                            x1="4"
                            y1="28"
                            x2="28"
                            y2="4"
                            stroke="#F05B5B"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                        />
                    </svg>
                )}
            </Box>
        </Box>
    );
};

export default ColorComponent;
